"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sesta-godano": {
    "a3b6506e": [{
      "hkey": "a71eaff2",
      "slug": "scogna-calabria-merzo",
      "name": "Scogna-Calabria-Merzò",
      "primary": true,
      "skipSearch": false
    }],
    "scogna": [{
      "hkey": "a71eaff2",
      "slug": "scogna-calabria-merzo",
      "name": "Scogna-Calabria-Merzò",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;